import React, { useEffect } from 'react'
import MattressGuide from '../components/OtherPages/MattressGuide'

export default function MattressGuidePage() {
   useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, []);
  return (
    <div>
      <MattressGuide/>
    </div>
  )
}
